import {
  ChangeDetectorRef,
  Component,
  effect,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom, map, Subscription, take, tap } from 'rxjs';
import { RecipientService } from 'src/app/screens/recipient/services/recipient.service';
import { AddRecipientService } from '../../services/add-recipient.service';
import { Location } from '@angular/common';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { UtilsService } from 'src/app/modules/shared/services/utils.service';
import * as moment from 'moment';
import { LookUpService } from 'src/app/modules/shared/services/look-up.service';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/modules/shared/services';
import { LocalStorageService } from 'src/app/modules/core/services/local-storage.service';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from '../../../../modules/i18n/i18n.service';
import { Title } from '@angular/platform-browser';
import { UserService } from 'src/app/modules/core/services/user.service';
import { EncDecService } from 'src/app/modules/shared/services/encryption-decryption.service';
import { CommonStoreData } from 'src/app/modules/core/store/common.signal.store';
import { SessionService } from 'src/app/screens/session/services/session.service';
import { SharedModule } from 'src/app/modules/shared/shared.module';
import { IonicModule } from '@ionic/angular';
import { patchState, signalState } from '@ngrx/signals';
import {
  AshaListState,
  VaccinatedInfoState,
  VillageState,
} from './generic-vaccination.model';
import { AllMaterialsStoreData } from 'src/app/modules/core/store/materials.signal.store';
import { VaccinatedInfoStoreData } from './vaccinated-info.signal.store';

@Component({
  selector: 'app-generic-vaccination',
  templateUrl: './generic-vaccination.component.html',
  styleUrls: ['./generic-vaccination.component.scss'],
})
export class GenericVaccinationComponent implements OnInit, OnDestroy {
  readonly commonStore = inject(CommonStoreData);
  readonly util = inject(UtilsService);
  readonly router = inject(Router);
  readonly dataService = inject(DataService);
  readonly addRecipientService = inject(AddRecipientService);
  readonly lookupService = inject(LookUpService);
  readonly localStorage = inject(LocalStorageService);
  readonly userService = inject(UserService);
  readonly allMaterialsStore = inject(AllMaterialsStoreData);
  readonly recipientService = inject(RecipientService);

  @Input() activeStepIndex = null;
  @Output() onStepChange: EventEmitter<any> = new EventEmitter();
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  form: FormGroup;
  selectedIndex: number = 0;
  benfSubscription: Subscription;
  verifiedData: any = {};
  benficiaryId;
  maxDoseDate = new Date();
  minDoseDate = new Date();
  showPrevBtn = false;
  villageDetails = [];
  healthVillagesDetails = [];
  wardDetails = [];
  healthWardDetails = [];
  dataSubsc: Subscription;
  readonly vaccinatedInfoStore = inject(VaccinatedInfoStoreData);

  readonly villageState = signalState<VillageState>({
    loading: false,
    error: null,
    villageArr: [],
    healthVillageArr: [],
    wardArr: [],
    healthWardArr: [],
  });

  readonly ashaListState = signalState<AshaListState>({
    loading: false,
    error: null,
    ashaList: [],
  });

  constructor() {
    this.initForm();
    effect(() => {});
  }

  ngOnInit(): void {
    this.allMaterialsStore.getAllMaterials();
    this.getVillageBySite();
  }

  initForm() {
    this.form = new FormGroup({
      materialDetails: new FormArray([]),
      village_id: new FormControl(null),
      health_village_id: new FormControl(null),
      ward_id: new FormControl(null),
      health_ward_id: new FormControl(null),
      tag_session_site: new FormControl(null),
      asha_user_id: new FormControl(null),
    });
  }

  getVillageBySite() {
    this.dataSubsc = this.dataService.userData.subscribe(async (res) => {
      if (res) {
        patchState(this.villageState, {
          loading: true,
          error: null,
        });
        const siteVillages = await firstValueFrom(
          this.lookupService.getSiteVillages()
        );
        patchState(this.villageState, {
          loading: true,
          error: null,
          villageArr: siteVillages.villageData,
          healthVillageArr: siteVillages.healthVillageData,
          wardArr: siteVillages.wardData,
          healthWardArr: siteVillages.healthWardData,
        });
      }
    });
  }

  getAshaUsers() {
    if (this.localStorage.getItem('session_site_id')) {
      patchState(this.ashaListState, {
        loading: true,
        error: null,
      });

      this.userService.getActiveAsha().subscribe((r: any) => {
        const ashaList = _.orderBy(
          r,
          [
            (o) => {
              return o.session_site_id || '';
            },
            'name',
          ],
          ['asc', 'asc']
        );
        patchState(this.ashaListState, {
          loading: true,
          error: null,
          ashaList: ashaList,
        });
      });
    }
  }

  onChangelocation(e) {
    if (e) {
      this.form.get('tag_session_site').reset();
      this.form.get('tag_session_site').disable();
      this.form.get('tag_session_site').updateValueAndValidity();
    }
  }

  handleSessionSiteAndVillage(e) {
    if (e.checked === true) {
      this.form.get('village_id').reset();
      this.form.get('village_id').disable();
      this.form.get('village_id').updateValueAndValidity();

      this.form.get('health_village_id').reset();
      this.form.get('health_village_id').disable();
      this.form.get('health_village_id').updateValueAndValidity();

      this.form.get('ward_id').reset();
      this.form.get('ward_id').disable();
      this.form.get('ward_id').updateValueAndValidity();

      this.form.get('health_ward_id').reset();
      this.form.get('health_ward_id').disable();
      this.form.get('health_ward_id').updateValueAndValidity();
    } else {
      this.form.get('village_id').reset();
      this.form.get('village_id').enable();
      this.form.get('village_id').updateValueAndValidity();

      this.form.get('health_village_id').reset();
      this.form.get('health_village_id').enable();
      this.form.get('health_village_id').updateValueAndValidity();

      this.form.get('ward_id').reset();
      this.form.get('ward_id').enable();
      this.form.get('ward_id').updateValueAndValidity();

      this.form.get('health_ward_id').reset();
      this.form.get('health_ward_id').enable();
      this.form.get('health_ward_id').updateValueAndValidity();
    }
  }

  onTabChange(event) {
    this.selectedIndex = event;
    console.log('onTabChange', event);
  }

  reloadComponent() {
    this.benfSubscription = this.addRecipientService.benSuccessData.subscribe(
      (res) => {
        this.verifiedData = res;
        this.vaccinatedInfoStore.setBeneficiaryData(res);
        this.vaccinatedInfoStore.getVaccinatedInfoByBenf({
          beneficiary_reference_id: this.verifiedData.beneficiary_reference_id,
        });
      }
    );
  }

  gotoStep(val) {
    if (
      val == 'prev' &&
      !this.verifiedData?.isRejected &&
      this.util.getPlatformWidth() < environment.static_ids.TabResoltion
    ) {
      if (this.verifiedData.session_id) {
        this.router.navigate([`/session/${this.verifiedData.session_id}`]);
      } else {
        this.router.navigate([`/dashboard`]);
      }
    } else {
      this.onStepChange.emit(val);
    }
  }

  disablePreviousVaccinationTab() {
    if (
      this.verifiedData &&
      this.verifiedData?.dob == moment().format('DD-MMM-YYYY')
    ) {
      return true;
    } else {
      return false;
    }
  }

  closeDialog() {
    this.onClose.emit();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeStepIndex) {
      if (this.activeStepIndex == 'MULTIVACCUIP') {
        this.reloadComponent();
      } else {
        this.unSubscribe();
      }
    }
  }
  unSubscribe() {
    if (this.benfSubscription) this.benfSubscription.unsubscribe();
    if (this.dataSubsc) this.dataSubsc.unsubscribe();
  }

  ngOnDestroy(): void {}
}
